// Generates a random temporary password, e.g. "Kp7mQx2Rwa".
// Skips look-alike characters (0/O, 1/l/I) so it's easy to read out or type.
const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';

export function generateTempPassword(length = 10) {
  const bytes = new Uint32Array(length);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => CHARS[b % CHARS.length]).join('');
}
